module.exports = __webpack_public_path__ + "static/media/Rectangle 12893.95040052.png";